import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function PSR() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/psr').then(r => setData(r.data.data)).finally(() => setLoading(false));
  }, []);

  const scoreColor = (s) => s >= 80 ? 'success' : s >= 60 ? 'warning' : 'danger';

  return (
    <>
      <h5 className="fw-bold mb-4">Performance Status Report</h5>
      {loading ? (
        <div className="text-center py-4"><div className="spinner-border text-primary" /></div>
      ) : (
        <>
          <div className="row g-3 mb-4">
            {[
              { label: 'Latest Score',   value: data?.latest_score != null ? `${data.latest_score}%` : '—', icon: 'bi-star-fill', color: 'warning' },
              { label: 'Average Score',  value: data?.avg_score != null ? `${data.avg_score}%` : '—',  icon: 'bi-graph-up',   color: 'primary' },
              { label: 'Total Entries',  value: data?.records?.length ?? 0, icon: 'bi-clipboard-check', color: 'success' },
            ].map(c => (
              <div className="col-md-4" key={c.label}>
                <div className="stat-card text-center">
                  <i className={`bi ${c.icon} text-${c.color} fs-3 mb-2`} />
                  <div className="fs-3 fw-bold">{c.value}</div>
                  <div className="text-muted small">{c.label}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="table-card">
            <table className="table table-hover align-middle mb-0">
              <thead><tr><th>Week</th><th>Score</th><th>Remarks</th><th>Date</th></tr></thead>
              <tbody>
                {data?.records?.length === 0 ? (
                  <tr><td colSpan={4} className="text-center text-muted py-4">No PSR records yet</td></tr>
                ) : data?.records?.map(r => (
                  <tr key={r.id}>
                    <td><span className="badge bg-primary-subtle text-primary">Week {r.week_no}</span></td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div className="progress flex-grow-1" style={{height:8,maxWidth:100}}>
                          <div className={`progress-bar bg-${scoreColor(r.score)}`} style={{width:`${r.score}%`}} />
                        </div>
                        <span className={`fw-bold text-${scoreColor(r.score)}`}>{r.score}%</span>
                      </div>
                    </td>
                    <td className="text-muted small">{r.remarks || '—'}</td>
                    <td className="text-muted small">{new Date(r.created_at).toLocaleDateString('en-IN')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}
